/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'stLocMainHeaderEspot-rv' },
    { emsName: 'stLocMainFooterEspot-rv' }
];
export default contentItems;
